import { Location } from 'history';
import { WorkOrderTask } from '__generated__/graphql';
import getQueryParameters from '../../../libs/getQueryParameters';

export const getWorkOrderTask = (
  location: Location,
  tasks: WorkOrderTask[],
): WorkOrderTask | undefined => {
  const queryParameters = getQueryParameters(location);
  const taskId = queryParameters['taskId'];
  const taskType = queryParameters['task'];
  return taskId
    ? tasks?.find((task: WorkOrderTask) => task.id === taskId)
    : tasks?.find(
        (task: WorkOrderTask) =>
          task.definition?.workOrderTaskType === taskType,
      );
};
